import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HttpModule } from '@angular/http';
import { DialogModule, TooltipModule } from 'primeng/primeng';
import { ReportsRoutingModule } from './reports-routing.module';
import { ViewAllPrintJobsHomeComponent } from './view-all-print-jobs/view-all-print-jobs-home.component';
import { ViewAllPrintJobsSearchComponent } from './view-all-print-jobs/view-all-print-jobs-search/view-all-print-jobs-search.component';
import { ViewMyPrintJobsHomeComponent } from './view-my-print-jobs/view-my-print-jobs-home.component';
import { ViewMyPrintJobsSearchComponent } from './view-my-print-jobs/view-my-print-jobs-search/view-my-print-jobs-search.component';
import { SharedModule } from '../../shared/shared.module';
import { SCECoreModule } from 'sce-core';
import { ReportsConfigurationHomeComponent } from './reports-configuration/reports-configuration-home/reports-configuration-home.component';
// tslint:disable-next-line:max-line-length
import { ReportsConfigurationSearchComponent } from './reports-configuration/reports-configuration-home/reports-configuration-search/reports-configuration-search.component';
import { ReportsConfigurationDetailsComponent } from './reports-configuration/reports-configuration-home/reports-configuration-details/reports-configuration-details.component';
import { MaintainReportHomeComponent } from './maintain-report/maintain-report-home/maintain-report-home.component';
import { MaintainReportSearchComponent } from './maintain-report/maintain-report-home/maintain-report-search/maintain-report-search.component';
import { MaintainReportDetailsComponent } from './maintain-report/maintain-report-home/maintain-report-details/maintain-report-details.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReportsRoutingModule,
    HttpModule,
    DialogModule,
    TooltipModule,
    SharedModule,
    SCECoreModule
  ],
  declarations: [
    
    ViewAllPrintJobsHomeComponent,
    ViewAllPrintJobsSearchComponent,
    ViewMyPrintJobsHomeComponent,
    ViewMyPrintJobsSearchComponent,
    ReportsConfigurationHomeComponent,
    ReportsConfigurationSearchComponent,
    ReportsConfigurationDetailsComponent,
    MaintainReportHomeComponent,
    MaintainReportSearchComponent,
    MaintainReportDetailsComponent
  ],
  exports: [
    
  ],
  entryComponents: [
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ReportsModule { }



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/reports/reports.module.ts